import React from "react";

const FormHeader = ({headerName, className}: FormHeaderProps) => (
    <div className="row ml-0 mr-0 mc-form-heading">
        <div className="col modifier">
            <h5 className={`mb-0 ${className || ""}`}>{headerName}</h5>
        </div>
    </div>
);

export default FormHeader;

interface FormHeaderProps {
    headerName: string;
    className?: string;
}
